import { domReady } from "../helpers"

domReady(async function () {
  const $charts = $(".report-charts .report-chart")
  if (!$charts.length) return

  if (!window.Snap) await import("snapsvg")

  const polar_to_cartesian = function (cx, cy, radius, angle) {
    const radians = ((angle - 90) * Math.PI) / 180.0
    return [
      Math.round((cx + radius * Math.cos(radians)) * 100) / 100,
      Math.round((cy + radius * Math.sin(radians)) * 100) / 100,
    ]
  }

  const svg_circle_arc_path = function (x, y, radius, start_angle, end_angle) {
    const start_xy = polar_to_cartesian(x, y, radius, end_angle)
    const end_xy = polar_to_cartesian(x, y, radius, start_angle)
    return `M ${start_xy[0]} ${start_xy[1]} A ${radius} ${radius} 0 0 0 ${end_xy[0]} ${end_xy[1]}`
  }

  const animate_arc_metric = function (mval, svg, perc, opts = {}) {
    if (mval == null) {
      perc.html("--")
      return
    }
    const scale = opts["scale"] || 100
    const suffix = opts["suffix"] || "<small>%</small>"
    const precision = opts["precision"] || 0

    let arc = svg.path("")
    Snap.animate(
      0,
      mval,
      function (val) {
        arc.remove()
        const path = svg_circle_arc_path(500, 500, 450, -90, val * 180.0 - 90)
        arc = svg.path(path)
        arc.attr({
          class: "data-arc",
          fill: "none",
          strokeWidth: 75,
        })
        perc.html((val * scale).toFixed(precision) + suffix)
      },
      Math.round(2000 * mval),
      mina.easeinout
    )
  }

  const animate_bar_metric = function (mval, svg, perc, opts = {}) {
    if (mval == null) {
      perc.html("--")
      return
    }
    const scale = opts["scale"] || 100
    const suffix = opts["suffix"] || "<small>%</small>"
    const precision = opts["precision"] || 0

    const bar = svg.rect(0, 0, 0, 0)
    Snap.animate(
      0,
      mval,
      function (val) {
        bar.remove()
        const rect = svg.rect(0, 0, val * 1000, 60)
        rect.attr({
          class: "data-bar",
          stroke: "none",
        })
        perc.html((val * scale).toFixed(precision) + suffix)
      },
      Math.round(2000 * mval),
      mina.easeinout
    )
  }

  const draw_arc_metric_bg = function (svg) {
    let arc = svg.path("")
    const path = svg_circle_arc_path(500, 500, 450, -90, 90)
    arc = svg.path(path)
    arc.attr({
      class: "bg-arc",
      fill: "none",
      strokeWidth: 75,
    })
  }

  const draw_bar_metric_bg = function (svg) {
    const rect = svg.rect(0, 0, 1000, 60)
    rect.attr({
      class: "bg-bar",
      stroke: "none",
    })
  }

  $charts.each(function () {
    let opts = {}
    if ($(this).hasClass("mood")) {
      opts["scale"] = 10
      opts["precision"] = 1
      opts["suffix"] = "<small>/10</small>"
    }

    const mval = $(this).data("mval")
    const svg_arc_id = $(this).data("cida")
    const svg_bar_id = $(this).data("cidb")
    const svg_arc = Snap(`#${svg_arc_id}`)
    const svg_bar = Snap(`#${svg_bar_id}`)
    const perc_arc = $(this).find("h3.percentage.arc")
    const perc_bar = $(this).find("h3.percentage.bar")
    draw_arc_metric_bg(svg_arc)
    draw_bar_metric_bg(svg_bar)
    animate_arc_metric(mval, svg_arc, perc_arc, opts)
    animate_bar_metric(mval, svg_bar, perc_bar, opts)
  })
})
